import { render, staticRenderFns } from "./QuestionSelector.vue?vue&type=template&id=05095fe4&"
import script from "./QuestionSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionSelector.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VNavigationDrawer,VStepper,VStepperStep})
